import { actionTypes } from "./actions";

const initialState = {
  data: [],
  keyPosEdit: {
    POSEZDPOSCode: "",
    POSPOSISPOSCode: "",
    POSLegalName: "",
    POSStreet: "",
    POSStreetNumber: "",
    POSCity: "",
    POSDistrict: "",
    POSXCoordinate: 0,
    POSYCoordinate: 0,
    POSAlternateXCoordinate: 0,
    POSAlternateYCoordinate: 0,
    POSVisited: 0,
    POSActivatable: 0,
    POSDecentralized: 0,
    KeyPOSHotZone: 0,
    KAChainDescription: "",
    KeyPOSChannelDescription: "",
    KeyPOSLocationDescription: "",
    KeyPOSKAOwnerDescription: "",
    KeyPOSKAAgreementDescription: "",
    KeyPOSCigarCaseDescription: "",
    KeyPOSCigarTypeDescription: "",
    KeyPOSQuantityOfModulesDescription: "",
    KeyPOSSecondaryMaterialCodeDescription: "",
  },
  fieldControls: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SET_KEY_POS:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_KEY_POS_BY_ID:
      return {
        ...state,
        keyPosEdit: payload,
      };

    case actionTypes.EDIT_KEYPOS_FORM_CHANGE:
      return {
        ...state,

        keyPosEdit: {
          ...state.keyPosEdit,
          [payload.name]: payload.value,
        },
      };

    case actionTypes.SET_DYNAMIC_FIELD_CONTROL:
      return {
        ...state,
        fieldControls: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
